import * as React from 'react'

import { action, makeObservable, observable } from 'mobx'
import { inject, observer } from 'mobx-react'

import {
  Radio,
  RadioGroup,
} from '~/client/src/shared/components/shadcn-ui/radio-group'
import {
  CancelationReason,
  cancelationReasonsList,
} from '~/client/src/shared/enums/CancelationReason'
import InitialState from '~/client/src/shared/stores/InitialState'
import getCancelationReasonTitle from '~/client/src/shared/utils/getCancelationReasonTitle'

import StruxhubTextArea from '../../../StruxhubInputs/StruxhubTextArea'

// localization: translated

interface IProps {
  onChange: (reason?: string) => void

  state?: InitialState
}

@inject('state')
@observer
export default class ReasonOptions extends React.Component<IProps> {
  @observable private selectedOption: CancelationReason = null
  @observable private otherReason: string = null

  public constructor(props: IProps) {
    super(props)
    makeObservable(this)
  }

  public render() {
    return (
      <>
        <RadioGroup
          className="tw:my-3 tw:flex tw:flex-col tw:gap-2"
          value={this.selectedOption}
          onValueChange={this.onChangeReasonOption}
        >
          {this.availableReasons.map((option, index) => (
            <label
              key={index}
              className="tw:inline-flex tw:items-center tw:gap-2 tw:cursor-pointer tw:select-none"
            >
              <Radio value={option} />
              <span>{getCancelationReasonTitle(option)}</span>
            </label>
          ))}
        </RadioGroup>
        {this.isOtherReason && (
          <StruxhubTextArea
            isMinimalisticMode={true}
            value={this.otherReason}
            onChange={this.onInputOtherReason}
          />
        )}
      </>
    )
  }

  @action.bound
  private onInputOtherReason(event: React.FormEvent<HTMLTextAreaElement>) {
    this.otherReason = event.currentTarget.value
    this.props.onChange(this.otherReason)
  }

  @action.bound
  private onChangeReasonOption(value: CancelationReason) {
    this.selectedOption = value
    this.props.onChange(getCancelationReasonTitle(this.selectedOption))

    if (this.isOtherReason) {
      this.otherReason = null
      this.props.onChange(null)
    }
  }

  private get isOtherReason(): boolean {
    return this.selectedOption === CancelationReason.Other
  }

  private get availableReasons(): CancelationReason[] {
    const { hiddenCancelationReasons } =
      this.props.state.delivery.configurations

    return cancelationReasonsList.filter(
      r => !hiddenCancelationReasons.includes(r),
    )
  }
}
